export * from '@primeuix/themes/lara/treeselect';
export { default } from '@primeuix/themes/lara/treeselect';
